const comparableValue = (value, numeric) => {
  if (value === null || value === undefined || String(value).trim() === '') return null;
  const text = String(value).trim();
  if (!numeric) return text.toLowerCase();
  const number = Number(text.replace(/,/g, ''));
  return Number.isFinite(number) ? number : null;
};

export const comparisonFilterOptions = [
  ['greaterThan', 'Greater than', (value, lower) => value > lower],
  ['lessThan', 'Less than', (value, lower) => value < lower],
  ['lessThanOrEqual', 'Less than or equal to', (value, lower) => value <= lower],
  ['greaterThanOrEqual', 'Greater than or equal to', (value, lower) => value >= lower],
  ['inRange', 'Between', (value, lower, upper) => value >= lower && value <= upper],
].map(([displayKey, displayName, compare]) => ({
  displayKey,
  displayName,
  numberOfInputs: displayKey === 'inRange' ? 2 : 1,
  predicate: (filterValues, cellValue) => {
    // Choose from the bounds, so nonnumeric cells cannot match numeric ranges.
    const numeric = comparableValue(filterValues[0], true) !== null;
    const values = [cellValue, ...filterValues].map(value => comparableValue(value, numeric));
    return values.every(value => value !== null) && compare(...values);
  },
}));
